/**
 * Social Proof para Colecciones - CRO
 * Muestra indicadores de "personas viendo" y "comprado recientemente"
 * Autor: Carlos Hernandez
 */

class ChCollectionSocialProof {
  constructor() {
    this.viewersData = new Map();
    this.purchaseData = new Map();
    this.init();
  }

  init() {
    // Simular personas viendo productos (para demo, en producción usar datos reales)
    this.simulateViewers();
    
    // Simular compras recientes
    this.simulateRecentPurchases();
    
    // Actualizar cada 5 segundos
    setInterval(() => {
      this.updateViewers();
      this.updateRecentPurchases();
    }, 5000);
  }

  simulateViewers() {
    const productCards = document.querySelectorAll('[data-product-id]');
    productCards.forEach((card) => {
      const productId = card.dataset.productId;
      if (productId) {
        // Simular entre 1-15 personas viendo
        const viewers = Math.floor(Math.random() * 15) + 1;
        this.viewersData.set(productId, viewers);
      }
    });
    
    // También buscar en elementos card__social-proof que tienen data-product-id
    const socialProofElements = document.querySelectorAll('.card__social-proof[data-product-id]');
    socialProofElements.forEach((element) => {
      const productId = element.dataset.productId;
      if (productId && !this.viewersData.has(productId)) {
        const viewers = Math.floor(Math.random() * 15) + 1;
        this.viewersData.set(productId, viewers);
      }
    });
  }

  simulateRecentPurchases() {
    const productCards = document.querySelectorAll('[data-product-id]');
    const times = ['5 minutos', '12 minutos', '18 minutos', '25 minutos', '35 minutos', '1 hora'];
    
    productCards.forEach((card) => {
      const productId = card.dataset.productId;
      if (productId) {
        // 30% de probabilidad de mostrar compra reciente
        if (Math.random() < 0.3) {
          const randomTime = times[Math.floor(Math.random() * times.length)];
          this.purchaseData.set(productId, randomTime);
        }
      }
    });
    
    // También buscar en elementos card__social-proof que tienen data-product-id
    const socialProofElements = document.querySelectorAll('.card__social-proof[data-product-id]');
    socialProofElements.forEach((element) => {
      const productId = element.dataset.productId;
      if (productId && !this.purchaseData.has(productId) && Math.random() < 0.3) {
        const randomTime = times[Math.floor(Math.random() * times.length)];
        this.purchaseData.set(productId, randomTime);
      }
    });
  }

  updateViewers() {
    // Buscar nuevos productos que puedan haberse agregado dinámicamente
    const allProductCards = document.querySelectorAll('[data-product-id]');
    allProductCards.forEach((card) => {
      const productId = card.dataset.productId;
      // Si el producto no está en el mapa, inicializarlo
      if (!this.viewersData.has(productId)) {
        const viewers = Math.floor(Math.random() * 15) + 1;
        this.viewersData.set(productId, viewers);
      }
    });
    
    // Buscar todos los elementos de viewers, incluso los que están dentro de card__social-proof
    const viewerElements = document.querySelectorAll('.card__viewers-count');
    viewerElements.forEach((element) => {
      // No mostrar en PDP (dentro de complementary-products, product-recommendations o related-products)
      if (element.closest('product-recommendations') || 
          element.closest('.complementary-products') || 
          element.closest('.related-products')) {
        return;
      }
      
      // Buscar el data-product-id más cercano (puede estar en card-wrapper o en card__social-proof)
      let card = element.closest('[data-product-id]');
      
      // Si no encuentra en el padre, buscar en el elemento social-proof mismo
      if (!card) {
        const socialProof = element.closest('.card__social-proof');
        if (socialProof && socialProof.dataset.productId) {
          card = socialProof;
        }
      }
      
      // Si aún no encuentra, buscar en card-wrapper
      if (!card) {
        card = element.closest('.card-wrapper');
      }
      
      if (!card || !card.dataset.productId) return;
      
      const productId = card.dataset.productId;
      const viewers = this.viewersData.get(productId) || 0;
      
      if (viewers > 0) {
        const numberEl = element.querySelector('.card__viewers-number');
        if (numberEl) {
          numberEl.textContent = viewers;
          element.style.display = 'inline-flex';
        }
      }
    });
  }

  updateRecentPurchases() {
    // Buscar nuevos productos que puedan haberse agregado dinámicamente
    const allProductCards = document.querySelectorAll('[data-product-id]');
    const times = ['5 minutos', '12 minutos', '18 minutos', '25 minutos', '35 minutos', '1 hora'];
    
    allProductCards.forEach((card) => {
      const productId = card.dataset.productId;
      // Si el producto no está en el mapa y tiene probabilidad, inicializarlo
      if (!this.purchaseData.has(productId) && Math.random() < 0.3) {
        const randomTime = times[Math.floor(Math.random() * times.length)];
        this.purchaseData.set(productId, randomTime);
      }
    });
    
    const purchaseElements = document.querySelectorAll('.card__recent-purchase');
    purchaseElements.forEach((element) => {
      // No mostrar en PDP (dentro de complementary-products, product-recommendations o related-products)
      if (element.closest('product-recommendations') || 
          element.closest('.complementary-products') || 
          element.closest('.related-products')) {
        return;
      }
      
      // Buscar el data-product-id más cercano (puede estar en card-wrapper o en card__social-proof)
      let card = element.closest('[data-product-id]');
      
      // Si no encuentra en el padre, buscar en el elemento social-proof mismo
      if (!card) {
        const socialProof = element.closest('.card__social-proof');
        if (socialProof && socialProof.dataset.productId) {
          card = socialProof;
        }
      }
      
      // Si aún no encuentra, buscar en card-wrapper
      if (!card) {
        card = element.closest('.card-wrapper');
      }
      
      if (!card || !card.dataset.productId) return;
      
      const productId = card.dataset.productId;
      const purchaseTime = this.purchaseData.get(productId);
      
      if (purchaseTime) {
        const timeEl = element.querySelector('.card__purchase-time');
        if (timeEl) {
          timeEl.textContent = purchaseTime;
          element.style.display = 'inline-flex';
        }
      }
    });
  }
}

// Inicializar cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.chCollectionSocialProof = new ChCollectionSocialProof();
  });
} else {
  window.chCollectionSocialProof = new ChCollectionSocialProof();
}

